export default "__VITE_ASSET__0ab3d3df__"